
import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '@/views/Home3'

import MenuUsuario from '@/components/plantilla/MenuUsuario.vue';

import MenuStorePrincipal from '@/components/plantilla/MenuStorePrincipal.vue';

import RutasStore from '@/components/plantilla/RutasStore.vue';

import MenuAdmin from '@/components/plantilla/MenuAdmin';

import MenuPerfil from '@/components/plantilla/MenuPerfil';


import MenuHome from '@/components/plantilla/MenuHome';



Vue.use(VueRouter)

const routes = [ 

  {
  path: '/',
  component: MenuStorePrincipal,
  children: [
    {
      path: '',
      redirect: 'store/all'
    },
    {
      path: 'store/:identificador',
      name: 'homeTiendaAll',
      component: () => import('../views/tienda/HomeTiendaAll.vue'),
      props: true
    },
    {
      path: '/about-store',
      name: 'about-store',
      component: () => import(/* webpackChunkName: "about" */ '../components/tienda/menu/AboutStore.vue')
    },

  ]
},

// Blog público con layout RutasStore
{
  path: '/blog',
  component: RutasStore,
  children: [
    {
      path: '',
      name: 'blog',
      component: () => import(/* webpackChunkName: "blog-public" */ '../views/forum/BlogPublicV.vue')
    },
    {
      path: 'categoria/:categoria',
      name: 'blog-categoria',
      component: () => import(/* webpackChunkName: "blog-public" */ '../views/forum/BlogPublicV.vue'),
      props: true
    },
    {
      path: ':url_post',
      name: 'blog-detail',
      component: () => import(/* webpackChunkName: "blog-public" */ '../views/forum/BlogDetailV.vue'),
      props: true
    }
  ]
},

// Eventos público con layout RutasStore
{
  path: '/eventos',
  component: RutasStore,
  children: [
    {
      path: '',
      name: 'eventos',
      component: () => import(/* webpackChunkName: "event-public" */ '../views/event/EventPublicV.vue')
    },
    {
      path: ':slug',
      name: 'evento-detail',
      component: () => import(/* webpackChunkName: "event-public" */ '../views/event/EventDetailV.vue'),
      props: true
    }
  ]
},

//AGREGAR EL PATH /store-carrito con el componente base necesario que puede estar en components/tienda/carrito 

{
  path: '/store-carrito',
  component: RutasStore,
  children: [
    {
      path: '',
      name: 'carritoCompra',
      component: () => import(/* webpackChunkName: "carrito" */ '../components/tienda/carrito/CarritoCompra.vue')
    }
  ]
},

  
  {
    path: '/linkstec',
    component: RutasStore,
    children: [
      {
        path: '/',
       name: 'linkstec',
       component: () => import(/* webpackChunkName: "blog" */ '../views/Home3.vue')
      }
      
      ,
      {
        path: '/prueba',
        name: 'prueba',
        component: () => import(/* webpackChunkName: "blog" */ '../components/prueba/PruebaCa.vue')
      },
      {
        path: '/perfiles',
        name: 'perfiles',
        component: () => import(/* webpackChunkName: "blog" */ '../components/perfiles/PerfilesView.vue')
      },
      {
        path: '/register_public',
        name: 'register_public',
        component: () => import(/* webpackChunkName: "usuario" */ '../views/UsuarioRegisterV.vue')
        },
    
  
  
  ]
  },

  {
    path: '/',
    name:'perfil',
    component: MenuPerfil,
    children: [
      {
        path: 'perfil/:identificador',
        name: 'perfil_hijo',
        component: () => import(/* webpackChunkName: "blog" */ '../views/PerfilV.vue')
      },
      {
        path: '/api/password/reset',
        name: 'pass_change',
        component: () => import(/* webpackChunkName: "blog" */ '../views/PassChangeV.vue'),
        // Para que los parámetros de la query sean parte de las props del componente
    //  props: (route) => ({ email: route.query.email, signature: route.query.signature, expires: route.query.expires }),
      },
      {
        path: '/api/email/verify',
        name: 'email_verify',
        component: () => import(/* webpackChunkName: "blog" */ '../views/EmailVerifyV.vue'),
      },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "blog" */ '../views/LoginView.vue')
    }
  ]
  },

  

  {
    //SECCION MENU ADMIN
    path: '/',
    component: MenuAdmin,
    children: [
      {
      path: '/ecommerce',
      name: 'ecommerce',
      component: () => import(/* webpackChunkName: "ecommerce" */ '../views/tienda/EcommerceHubV.vue')
      },
      {
      path: '/data_empresa',
      name: 'data_empresa',
      component: () => import(/* webpackChunkName: "empresa" */ '../views/EmpresaDataV.vue')
      }
      ,
      {
      path: '/vendedor',
      name: 'vendedor',
      component: () => import(/* webpackChunkName: "categoria" */ '../views/tienda/VendedorV.vue')
      } ,

 ,
      {
      path: '/categoria',
      name: 'categoria',
      component: () => import(/* webpackChunkName: "categoria" */ '../views/tienda/CategoriaV.vue')
      },


      {
      path: '/proveedor',
      name: 'proveedor',
      component: () => import(/* webpackChunkName: "proveedor" */ '../views/tienda/ProveedorV.vue')
      } ,
      {
      path: '/producto',
      name: 'producto',
      component: () => import(/* webpackChunkName: "producto" */ '../views/tienda/ProductoV.vue')
      } ,
        {
          path: '/imagenes_base',
             name: 'imagenesbase',
           component: () => import(/* webpackChunkName: "imagenesbase" */ '../views/ImagenesBaseV.vue')
        },
        {
          path: '/compra',
          name: 'compra',
          component: () => import(/* webpackChunkName: "compra" */ '../views/tienda/CompraV.vue')
        },
        {
          path: '/venta',
          name: 'venta',
          component: () => import(/* webpackChunkName: "venta" */ '../views/tienda/VentaV.vue')
        },
        {
          path: '/pedidos',
          name: 'pedidos',
          component: () => import(/* webpackChunkName: "pedido" */ '../views/tienda/PedidoV.vue')
        },
        {
          path: '/forum-admin',
          name: 'forum_admin',
          component: () => import(/* webpackChunkName: "forum" */ '../views/forum/ForumAdminV.vue')
        },
        {
          path: '/eventos-admin',
          name: 'eventos_admin',
          component: () => import(/* webpackChunkName: "event" */ '../views/event/EventAdminV.vue')
        },
        {
          path: '/admin-general',
          name: 'admin_general',
          component: () => import(/* webpackChunkName: "admin" */ '../views/AdminGeneralHubV.vue')
        },
        {
          path: '/linkstec-admin',
          name: 'linkstec_admin',
          component: () => import(/* webpackChunkName: "linkstec" */ '../views/LinksTecHubV.vue')
        },
        {
          path: '/imagenes_base',
             name: 'imagenesbase',
           component: () => import(/* webpackChunkName: "imagenesbase" */ '../views/ImagenesBaseV.vue')
        },
        {
          path: '/logout',
          name: 'logout',
          component: () => import(/* webpackChunkName: "blog" */ '../views/Logout.vue')
        },
        {
          path: '/principal',
          name: 'principal',
          component: () => import(/* webpackChunkName: "principal" */ '../views/PrincipalV.vue')
          },  {
            path: '/opcion',
            name: 'opcion',
            component: () => import(/* webpackChunkName: "opcion" */ '../views/OpcionV.vue')
            }


    ]
},

{
  path: '/',
  component: MenuUsuario,
  children: [


      {
      path: '/register_producto_user',
      name: 'register_producto_user',
      component: () => import(/* webpackChunkName: "producto" */ '../views/tienda/RegisterProductoUsuarioV.vue')
      } ,

    {
      path: '/data_user',
      name: 'data_user',
      component: () => import(/* webpackChunkName: "usuario" */ '../views/UsuarioDataV.vue')
      }
      ,
    {
      path: '/mis-pedidos',
      name: 'mis_pedidos',
      component: () => import(/* webpackChunkName: "pedido" */ '../views/tienda/MisPedidosV.vue')
      }
      ,
    
    {
      path: '/registro_comprobantes',
      name: 'registro_comprobantes',
      component: () => import(/* webpackChunkName: "empresa" */ '../views/RegistroComprobantesV.vue')
      }
      ,
    {
      path: '/registro_compra',
      name: 'registro_compra',
      component: () => import(/* webpackChunkName: "empresa" */ '../components/economy/RegistroCompra.vue')
      }
      ,
    {
      path: '/register',
      name: 'register',
      component: () => import(/* webpackChunkName: "usuario" */ '../views/UsuarioRegisterV.vue')
      },
      {
        path: '/perfil/:identificador/add/',
        name: 'add',
        component: () => import(/* webpackChunkName: "usuario" */ '../views/PrincipalRegisterV.vue')
        },
    {
      path: '/about',
      name: 'about',
      component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    },
    {
      path: '/pruebaimg',
      name: 'pruebaimg',
      component: () => import(/* webpackChunkName: "about" */ '../components/prueba/PruebaImg.vue')
    },
    {
      path: '/pruebamapa',
      name: 'pruebamapa',
      component: () => import(/* webpackChunkName: "about" */ '../components/prueba/MapaMundial.vue')
    }
    
    ,// {
     // path: '/logout',
     // name: 'logout',
     // component: () => import(/* webpackChunkName: "blog" */ '../views/Logout.vue')
    //}
    
    , 
  //	{
   //   path: '/imagenes_base',
   //   name: 'imagenesbase',
   //   component: () => import(/* webpackChunkName: "imagenesbase" */ '../views/ImagenesBaseV.vue')
    //	}*/
      ,
 //   {
   //   path: '/prueba',
  //    name: 'prueba',
  //    component: () => import(/* webpackChunkName: "blog" */ '../views/PruebaV.vue')
  //  }
      
  ]
},



//{
  //  path: '/',
  //  name: 'store',
  //  component: MenuStorePrincipal,
 //   children: [
     
 //     {
    //    path: '/store/:identificador',
   //     name: 'homeTiendaAll',
   //     component: () => import(/* webpackChunkName: "blog" */ '../views/tienda/HomeTiendaAll.vue'),
   //     props: true
   //   }     
    
    
//  ]
//  }




	

] 

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// ─── NAVIGATION GUARD: protección por roles ─────────────────────────────────
const routeRoleMap = {
  '/ecommerce': ['admin', 'seller'],
  '/forum-admin': ['admin', 'author'],
  '/eventos-admin': ['admin', 'event'],
  '/linkstec-admin': ['admin', 'links'],
  '/admin-general': ['admin'],
};

router.beforeEach((to, from, next) => {
  const requiredRoles = routeRoleMap[to.path];
  if (!requiredRoles) return next();

  const token = localStorage.getItem('token');
  if (!token) return next('/login');

  const roles = JSON.parse(localStorage.getItem('roles') || '[]');
  if (requiredRoles.some(r => roles.includes(r))) {
    next();
  } else {
    next('/login');
  }
});

export default router

